<template>
  <section v-if="user.information">
      <ejs-schedule v-if="loaded" :key="redrawKey"      
        readOnly="true" 
        :locale="user.information.locale" 
        :currentView="currentView"
        showHeaderBar="false"
        allowInline="false"
        allowMultiRowSelection="false"
        showQuickInfo="false"
        @navigating="navigating"
        :eventSettings='eventSettings' :eventClick="onEventClick">

        <e-views>
          <e-view option="Day" :eventTemplate='agendaEventTemplate'></e-view>
          <e-view option="Week" :eventTemplate='agendaEventTemplate'></e-view>
          <e-view option="WorkWeek" :eventTemplate='agendaEventTemplate'></e-view>
          <e-view option="Month" :eventTemplate='agendaEventTemplate'></e-view>
          <e-view option="Agenda" :eventTemplate='agendaEventTemplate'></e-view>
      </e-views>

        </ejs-schedule>

  </section>
</template>
<script>
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';
import localeText from '@/locales/calendar.json';
loadCldr(require("cldr-data/supplemental/numberingSystems.json"), require("cldr-data/main/sv/ca-gregorian.json"), require("cldr-data/main/sv/numbers.json"), require("cldr-data/main/sv/timeZoneNames.json"));
import { Day, Week, WorkWeek, Month, Agenda } from '@syncfusion/ej2-vue-schedule';
import AgendaEventTemplate from "@/components/Calendar/AgendaEventTemplate";
class CustomAdaptor extends ODataV4Adaptor {
    processResponse() {
        let original = super.processResponse.apply(this, arguments);
        let arr = original.items.map(item => (
          { 
            Id: item.message.id,
            Subject: item.message.subject,
            Location: item.message.message_type,
            Description: '',
            StartTime: item.message.open_from_date,
            EndTime: item.message.open_to_date,
            IsReadonly: true,
            RoomId: item.message.message_type,
            MessageUuid: item.message.message_uuid
          }
        ));
        return  arr;
    }
}
export default {
  props: ["currentView","redrawView"],
  provide: {
    schedule: [Day, Week, WorkWeek, Month, Agenda]
  },
  components: {
  },
  data() {
    return {
      redrawIndex: 0,
      selectedDate: null,
      readOnly: true,
      items: [],
      limit: 500,
      totalItems: 0,
      localeText,
      loaded: false,
      locale: 'sv',
      agendaEventTemplate: function () {
          return { template: AgendaEventTemplate }
      },
      eventSettings: {
        
      }
    };
  },
methods: {
    navigating(){
      this.$emit('changedView', this.currentView);
    },
    onEventClick: function (obj) {
      this.$emit('clickedEvent', obj.event.MessageUuid);
    },
    init() {
      this.eventSettings.dataSource = new DataManager(
          {
              url: this.user.hostname + "/meetings/list",
              adaptor: new CustomAdaptor(),
              crossDomain: true,
              headers:[{ 'Authorization': "Bearer " + this.$cookies.get("token") }]
          }
        );
      setCulture(this.user.information.locale);
      L10n.load(this.localeText);
      this.loaded = true;
    },
    getSent: function(newDate) {
      let self = this;
      let currentDate = this.$luxonDateTime.fromJSDate(newDate);
      ////console.log(currentDate.month);
      this.loading = true;
      this.$http
        .post(this.user.hostname + "/meetings/list", {
          page: 0,
          limit: parseInt(this.limit),
          state: this.state,
          search_text: this.searchText,
          year: currentDate.year,
          month: currentDate.month
        })
        .then((response) => {
          self.$emit("changeUpdateMessageUuid", "");
          self.loading = false;
          self.items = response.data.items;
          self.totalItems = response.data.count;
        })
        .catch(() => {
          self.loading = false;
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    },
  },
  computed: {
    redrawKey(){
      return "events_" + this.redrawIndex;
    }
  },
  mounted: function() {
    this.init();
  },
};
</script>
<style></style>
